<template>
    <div
        class="question-wrapper"
        v-if="detailInfo.id">
		<detail-title
			:title="isAnswer ? '问答专区' : '文章专区'"
			:isShowTitle="isShowTitle"
			:detailInfo="detailInfo"
			:isEditor="isEditor"
			:isAnswer="isAnswer"
			@toPersonal="toPersonal"
			@editQuestion="editQuestion"
			@deletePop="deletePop">
		</detail-title>
		<section class="content-wrapper">
			<div class="left-content" v-show="initShow">
				<p class="comment-content" @click="scrollIntoComment">
					<span class="icon"></span>
					<span class="answered-total answers-num">{{detailInfo.no_of_comment || 0}}</span>
				</p>
				<el-tooltip
					effect="dark"
					popper-class="icon-tip"
					:content="detailInfo.is_followed ? '取消关注' : '关注'"
					placement="top">
					<p
						:class="['follow-content', { 'is-follow': detailInfo.is_followed }]"
						@click="focusToggle"
						v-if="isAnswer">
						<span class="icon"></span>
						<span class="focus-total answers-num">{{detailInfo.no_of_followed || 0}}</span>
					</p>
				</el-tooltip>
				<template v-if="!isAnswer">
					<el-tooltip
					effect="dark"
					popper-class="icon-tip"
					:content="detailInfo.is_vote_up ? '取消点赞' : '点赞'"
					placement="top">
						<p
							:class="['great-content', { 'is-great': detailInfo.is_vote_up }]"
							@click="onVoteToggle(detailInfo)">
							<span class="icon"></span>
							<span class="focus-total answers-num">{{detailInfo.no_of_vote_up || 0}}</span>
						</p>
					</el-tooltip>
					<el-tooltip
						effect="dark"
						popper-class="icon-tip"
						:content="detailInfo.is_liked ? '取消收藏' : '收藏'"
						placement="top">
						<p
							:class="['favorite-content', { 'is-favorite': detailInfo.is_liked }]"
							@click="favoriteToggle(detailInfo)">
							<span class="icon"></span>
							<span class="focus-total answers-num">{{detailInfo.no_of_likes || 0}}</span>
						</p>
					</el-tooltip>
				</template>
				<div class="share">
					<span>分享</span>
					<div class="social-share" data-initialized="true">
					<a href="#" class="social-share-icon icon-wechat"></a>
					<el-tooltip
						effect="dark"
						popper-class="icon-tip"
						content="分享至QQ"
						placement="top">
						<a href="#" class="social-share-icon icon-qq"></a>
					</el-tooltip>
					<el-tooltip
						effect="dark"
						popper-class="icon-tip"
						content="分享至微博"
						placement="top">
						<a href="#" class="social-share-icon icon-weibo"></a>
					</el-tooltip>
					</div>
					<el-tooltip
						effect="dark"
						popper-class="icon-tip"
						content="复制链接"
						placement="top">
						<span class="icon icon-copy" @click="onCopyUrl"></span>
					</el-tooltip>
				</div>
			</div>

			<div class="center-content">
				<div class="center-top-content">
					<div class="basic-info">
						<div  class="head-title">
							<div v-if="isShowTag" :class="[detailInfo.is_reprint ? 'reprint' : 'original']">{{detailInfo.is_reprint ? '转载' : '原创'}}</div>
							<img v-if="detailInfo.is_top" src="../../images/community/top.png" alt="" />
							<h1>{{ detailInfo.title }}</h1>
							<span v-if="detailInfo.comment_is_accept_by_topic" class="solved">已解决</span>
						</div>
						<div class="questioner-info" v-if="detailInfo.created_by">
							<el-popover
                  popper-class="user-card"
                  placement="top"
                  :open-delay="500"
                  width="400"
                  trigger="hover"
                  @show="$refs['card' + detailInfo.created_by.id].getUserInfo()">
                  <div style="text-align: right; margin: 0, padding: 0">
                      <user-card :ref="`card${detailInfo.created_by.id}`" :user-id="detailInfo.created_by.id"></user-card>
                  </div>
                  <div slot="reference" class="user-avatar" @click="visible = !visible">
											<span class="user-portrait" @click="toPersonal">
												<img
													class="identity-icon"
													width="26"
													height="26"
													src="../../images/personal_center/avatar_default.png"
													v-if="detailInfo.created_by.user_logo.substr(0, 1) == '?'"/>
												<img :src="detailInfo.created_by.user_logo" alt="" width="26" height="26" v-else />
											</span>
                  </div>
              </el-popover>
							<span class="questioner-name">{{detailInfo.created_by.nick_name}}</span>
							<el-tooltip v-if="detailInfo.created_by.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                <svg style="width: 20px; height: 20px" aria-hidden="true">
                	<use xlink:href="#icon-lanjingguanfang"></use>
                </svg>
              </el-tooltip>
              <el-tooltip v-if="detailInfo.created_by.is_vip" effect="light" content="核心用户" placement="right">
                <span class="icon-vipuser"></span>
              </el-tooltip>
							<span class="question-time">于{{ detailInfo.created_on }}</span>
							<span>发布</span>
							<p class="question-view">
								<i class="view-icon"></i>
								<span class="text">{{ detailInfo.no_of_views }}阅览</span>
							</p>
							<span style="marginLeft: 15px">更新于 {{ detailInfo.updated_on }}</span>
							<ul class="editor-list" v-if="isEditor">
								<li class="editor-btn" @click="editQuestion">编辑</li>
								<li class="delete-btn" @click="deletePop">删除</li>
							</ul>
						</div>
						<ul class="tags">
							<li
								v-for="(item, index) in detailInfo.tags"
								:key="index">
								{{ item.title }}
							</li>
						</ul>
					</div>
					<div
						class="question-content markdown-body"
						v-if="detailInfo.description !== '<p><br></p>' && detailInfo.description !== ''">
						<p
							class="question-desc img-hook"
							v-html="filterXSS(afterhtmlData)"
							ref="descHook"
							@click.stop="getImgUrl($event)">
						</p>
					</div>
				</div>
				<comment
					ref="comment"
					:isLogin="isLogin"
					:isAnswer="isAnswer"
					:curUserInfo="userInfo"
					:detailInfo="detailInfo"
					@onSwitchAccept="onSwitchAccept"
					@favoriteToggle="favoriteToggle"
					@focusToggle="focusToggle">
				</comment>
			</div>

			<div class="right-content" v-show="initShow">
				<communityRightContent
					ref="rightChild"
					:tags="detailInfo.tags"
					:isAnswer="isAnswer">
				</communityRightContent>
			</div>
			<v-alert :options="options"></v-alert>
			<goback></goback>
		</section>
    </div>
</template>
<script type="text/javascript">
	import vAlert from '../alert.vue'
	import mavonEditor from 'mavon-editor'
	import loading from '../loading.vue'
	import goback from '../common/goback.vue'
	import communityRightContent from '../common/communityRightContent.vue'
	import comment from './comment.vue'
	import detailTitle from './detailTitle.vue'
	import tools from '@/js/tools.js'
	import userCard from '../common/userCard.vue'
	import bus from '@/js/bus.js'
	export default {
		components: {
			vAlert,
			loading,
			goback,
			communityRightContent,
			comment,
			detailTitle,
			userCard
		},
		data() {
			return {
				initShow: false,
				isShowTitle: false,

				htmlData: '',
				// 内容详情
				afterhtmlData: '',

				// 存放实例化的wangEditor对象，在多个方法中使用
				editor: '',
				options: {
					// 消息弹窗
					msgText: '',
					msgIsSuccess: true,
				},
				// 一级评论&二级平来的区分
				parent_id: '',
				questionId: 1,
				pageAll: 0,
				detailInfo: {},
				shareUrl: '', // 分享链接
				metaSetting: {
					title: '',
					keywords: '',
					description: ''
				}
			}
		},
		metaInfo () {
            return {
                title: `${this.$route.query.type == 'article' ? '文章' : '问答'}` + '|' + this.metaSetting.title,
                meta: [
                    {
                        name: 'keywords',
                        content: this.metaSetting.keywords
                    },
                    {
                        name: 'description',
                        content: this.metaSetting.description
                    }
                ]
            }
        },
		computed: {
			// 是否显示原创、转载标签
			isShowTag() {
				const { type } = this.$route.query
				return type && type === 'article'
			},
			isLogin() {
				return this.$store.state.isLogin
			},
			userInfo() {
				return this.$store.state.userInfo
			},
			isEditor() {
				const isShowEditor =
					(this.detailInfo.created_by &&
					this.detailInfo.created_by.user_id === this.userInfo.user_id) ||
					this.userInfo.is_superuser
				return isShowEditor
			},
			isAnswer() {
				// 是否为问答详情页
				const query = this.$route.query
				return query.type === 'answer' || !query.type
			},
		},
		watch: {
			$route: {
				handler(val) {
					this.questionId = this.$route.params.wid;
					this.initQuestionDesc()
					this.$refs.rightChild.initRightContent()
				},
				deep: true
			},
		},
		async mounted() {
			await this.initQuestionDesc()
			// 设置meta
			const { title, tags, description } = this.detailInfo
			const keywords = tags.map(item => item.title).join(',')
			this.metaSetting = {
				title,
				keywords,
				description
			}

			/**
			 * 详情内容过长会有滚动条出现，会影响到相关问答栏的定位
			 * 于是设置页面加载.8s后，再去动态设置定位
			 */
			this.$nextTick(() => {
				this.shareUrl = window.location.href
				let $config = {
					url: this.shareUrl,
					title: this.detailInfo.title,
					image: [],
					sites: ['wechat', 'qq', 'weibo'], // 启用的站点
					wechatQrcodeTitle: '微信扫一扫：分享', // 微信二维码提示文字
					wechatQrcodeHelper:
					'<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>'
				}
				socialShare('.social-share', $config)
				this.handlerResize()
				this.initShow = true
			})
			this.createBrowseHistory()
			// 监听滚动事件
			window.addEventListener('scroll', this.handlerScroll)
			// 处理单条评论展开后，"收起"吸底效果
			window.addEventListener('resize', this.handlerResize)
		},
		destroyed() {
			window.removeEventListener('scroll', this.handlerScroll)
			window.removeEventListener('resize', this.handlerResize)
			localStorage.removeItem('page')
			localStorage.removeItem('parent_id')
		},
		methods: {
			// 创建浏览历史
			createBrowseHistory () {
				try {
					const params = {
						browse_time: this.handleFormat(),
						browse_type: this.isAnswer ? 'qa' : 'article',
						instance_id: this.detailInfo.id,
						instance_title: this.detailInfo.title
					}
                    axios.post(myUrl + 'history_browse/api/', params)
                } catch (error) {
                    console.warn(error)
                }
			},
			handleFormat () {
				const date = new Date()
				const year = date.getFullYear();
				const month = change(date.getMonth() + 1)
				const day = change(date.getDate())
				const hour = change(date.getHours())
				const minute = change(date.getMinutes())
				const second = change(date.getSeconds())
				function change(t) {
					if (t < 10) {
						return "0" + t
					} else {
						return t
					}
				}
				var time = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
				return time
			},
			// 复制路径
			onCopyUrl () {
				const url = window.location.href
				const title = `【${this.detailInfo.title}】\n`
				const result = this.copyText(title + url)
				if (result) {
					this.$message({
						message: '复制成功！',
						type: 'success',
					})
				}
			},
			// 复制文本
			copyText (text) {
				const textarea = document.createElement('textarea')
				textarea.setAttribute('readonly', '')
				textarea.style.position = 'absolute'
				textarea.style.left = '-9999px'

				document.body.appendChild(textarea)
				textarea.value = text

				textarea.select()
				let result = false
				try {
					result = document.execCommand('copy')
				} catch (error) {
					console.warn(error)
				}
				textarea.blur()
				document.body.removeChild(textarea)
				return result
			},
			// 滚动到评论区域
			scrollIntoComment () {
				this.$refs.comment.scrollIntoComment()
			},
			getImgUrl (event) {
				if (event.target.tagName.toUpperCase() === 'IMG') {
					let href = event.target.currentSrc
					if (href.indexOf('file') !== -1) {
						href = href.replace('file', 'cos-website.ap-shanghai')
					}
					if (/\.(png|jpg|gif|jpeg|bmp|webp)(\/)?$/i.test(href)) {
						window.open(href, '_blank')
					}
				}
			},
			deletePop () {
				this.$bkInfo({
					title: '确认要删除？',
					confirmFn: () => {
						this.deleteQuestion()
					}
				})
			},
			deleteQuestion () {
				const questionId = this.$route.params.wid
				axios.delete(myUrl + `forum/topics/${questionId}/`).then(res => {
					if (res.data.result) {
						this.$router.push({
							path: `/s-mart/community`
						})
					}
				})
			},
			// 编辑问题
			editQuestion () {
				const questionId = this.$route.params.wid
				this.$router.push({
					path: `/s-mart/community/ask/${questionId}/`,
					query: {
						type: this.isAnswer ? undefined : 'article'
					}
				})
			},
			// 去登录
			onLogin () {
				axios.get(myUrl + 'login/test/')
			},
			// 采纳&取消采纳
			onSwitchAccept () {
				this.initQuestionDesc()
			},
			// 关注&取消关注
			focusToggle () {
				if (!this.isLogin) {
					axios.get(myUrl + 'login/test/').then(res => {
						if (!res.data.result) return
					})
					return
				}
				// 校验信息是否完善
				if (!this.$store.state.informationComplete) {
					bus.$emit('openInformationPopup')
					return
				}
				let params = {
					topic_id: this.detailInfo.id,
					is_followed: !this.detailInfo.is_followed
				}

				axios.post(myUrl + 'forum/usertopic/', qs.stringify(params)).then(
					(res) => {
						if (!res.data.result) return;
						this.detailInfo.is_followed = !this.detailInfo.is_followed
						if (this.detailInfo.is_followed) {
							this.detailInfo.no_of_followed += 1
						} else {
							this.detailInfo.no_of_followed -= 1
						}
						this.$message({
							message: this.detailInfo.is_followed ? '关注成功' : '取消关注成功',
							type: 'success'
						})
					},
					(reject) => {
						this.options = {
							msgText: res.message,
							msgIsSuccess: false
						}
					}
				)
			},
			// 点赞&取消点赞
			onVoteToggle (val) {
				try {
					if (!this.isLogin) {
						axios.get(myUrl + 'login/test/').then(res => {
							if (!res.data.result) return
						})
						return
					}
					// 校验信息是否完善
					if (!this.$store.state.informationComplete) {
						bus.$emit('openInformationPopup')
						return
					}
					let params = {
						topic_id: val.id,
						vote: val.is_vote_up ? null : true
					}
					axios.post(myUrl + 'forum/usertopic/', params).then((res) => {
						if (res.data.result) {
							val.is_vote_up = val.is_vote_up ? null : true
							let msg = ''
							if (val.is_vote_up) {
								val.no_of_vote_up += 1
								msg = '点赞成功'
							} else {
								val.no_of_vote_up -= 1
								msg = '取消点赞成功'
							}
							this.$message({
								message: msg,
								type: 'success'
							})
						}
					})
				} catch (error) {
					console.warn(error)
				}
			},
			// 收藏&取消收藏
			favoriteToggle (val) {
				try {
					if (!this.isLogin) {
						axios.get(myUrl + 'login/test/').then(res => {
							if (!res.data.result) return
						})
						return
					}
					// 校验信息是否完善
					if (!this.$store.state.informationComplete) {
						bus.$emit('openInformationPopup')
						return
					}
					let params = {
						topic_id: val.id,
						is_like: !val.is_liked
					}
					axios.post(myUrl + 'forum/usertopic/', params).then((res) => {
						if (res.data.result) {
							val.is_liked = !val.is_liked
							let msg = ''
							if (val.is_liked) {
								val.no_of_likes += 1
								msg = '收藏成功'
							} else {
								val.no_of_likes -= 1
								msg = '取消收藏成功'
							}
							this.$message({
								message: msg,
								type: 'success'
							})
						}
					})
				} catch (error) {
					console.warn(error)
				}
			},
			// 获取到提问描述
			async initQuestionDesc () {
				try {
					let requestUrl = `forum/topics/${this.$route.params.wid}/`
					await axios.get(myUrl + requestUrl).then(res => {
						if (!res.data.result) return
						this.detailInfo = res.data.data
						// 判断拿到的text文字是不是Markdown，是的话前端需要进行转化
						if (this.detailInfo.format !== 'Markdown') {
							this.afterhtmlData = filterXSS(this.detailInfo.description)
						} else {
							this.htmlData = this.detailInfo.description
							this.$nextTick(() => {
								const data = mavonEditor.markdownIt.render(this.htmlData)
								const resData = tools.setImgCustomAttr(data)
                            	this.afterhtmlData = filterXSS(resData)
							})
						}
					})
				} catch (error) {
					console.warn(error)
				}
			},
			// 监听页面滚动
			handlerScroll () {
				// 导航栏是否展示用户信息和title
				let documentScroll = $(document).scrollTop()
				this.isShowTitle = documentScroll >= 20
				const fixedTitleDom = document.querySelector('.fixed-title')
				if (fixedTitleDom && !fixedTitleDom.style.left) {
					const centerContent = document.querySelector('.center-content')
					const centerLeft = centerContent && centerContent.getBoundingClientRect().left
					const left = centerLeft > 220 ? centerLeft : 220
					fixedTitleDom.style.left = left - 59 + 'px'
					fixedTitleDom.style.top = '10px'
				}

				// 返回顶部距离相关回答40px设置
				const goBackDom = document.querySelector('.go-back')
				if (goBackDom) {
					const centerContent = document.querySelector('.center-content')
					const centerLeft = centerContent && centerContent.getBoundingClientRect().left
					// 相关回答的left + 宽度 + 40
					goBackDom.style.left = centerLeft + 830 + 12 + 356 + 40 + 'px'
				}
			},
			// 跳转到个人中心
			toPersonal () {
				let userId = this.detailInfo.created_by.user_id
				// 判断是否为自己或者他人
				const isMatch = this.userInfo.user_id === userId
				const path = isMatch ? '/s-mart/personal_center/' : `/s-mart/personal_center/user/${userId}`
				let routeData = this.$router.resolve({
					path
				})

				window.open(routeData.href, '_blank')
			},
			// 监听页面尺寸变化
			handlerResize () {
				// 计算操作区域的left和相关问答left
				const leftContent = document.querySelector('.left-content')
				const centerContent = document.querySelector('.center-content')
				const centerLeft = centerContent && centerContent.getBoundingClientRect().left
				if (leftContent) {
					leftContent.style.left = centerLeft - 59 + 'px'
				}
				// 评论模块内容超出底部固定区域的left设置
				const fixBottomDom = document.querySelector('.fixed > .content-footer')
				if (fixBottomDom) {
					fixBottomDom.style.left = centerLeft + 'px'
				}

				// 标题用户详情left设置
				const fixedTitleDom = document.querySelector('.fixed-title')
				if (fixedTitleDom) {
					const left = centerLeft > 220 ? centerLeft : 220
					fixedTitleDom.style.left = left - 59 + 'px'
				}

				// 返回顶部距离相关回答40px设置
				const goBackDom = document.querySelector('.go-back')
				if (goBackDom) {
					// 相关回答的left + 宽度 + 40
					goBackDom.style.left = centerLeft + 830 + 12 + 356 + 40 + 'px'
				}
			}
		}
	}
</script>

<style lang="scss">
  .user-card {
		z-index: 2000;
    padding: 0 !important;
  }
	.bk-dialog {
		z-index: 100002 !important;
	}
	.icon-tip {
		z-index: 100000 !important;
	}
	.left-content {
		.share {
			width: 42px;
			height: 183px;
			background: #ffffff;
			border-radius: 2px;
			box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
			text-align: center;
			padding-top: 12px;
			color: #979ba5;
			.social-share {
				a {
					height: 14px;
					width: 14px;
					display: block;
					border: none;
					border-radius: 0;
					margin: 0 auto 22px;
					&::before {
						content: "";
					}
				}
				.icon-wechat {
					margin-top: 19px;
					background: url("../../images/community/weixin-shape.png");
					background-size: 100% 100%;
					.wechat-qrcode {
						z-index: 100001 !important;
					}
					&:hover {
						background: url("../../images/community/weixin-shape2.png");
						background-size: 100% 100%;
					}
				}
				.icon-qq {
					background: url("../../images/community/qq-shape.png");
					background-size: 100% 100%;
					&:hover {
						background: url("../../images/community/qq-shape2.png");
						background-size: 100% 100%;
					}
				}
				.icon-weibo {
					background: url("../../images/community/sina-shape.png");
					background-size: 100% 100%;
					&:hover {
						background: url("../../images/community/sina-shape2.png");
						background-size: 100% 100%;
					}
				}
			}
			.icon-copy {
				display: inline-block;
				height: 14px;
				width: 14px;
				cursor: pointer;
				background: url("../../images/community/link.png");
				background-size: 100% 100%;
				&:hover {
					background: url("../../images/community/link2.png");
					background-size: 100% 100%;
				}
			}
		}
	}
</style>
<style lang="scss" scoped type="text/scss">
	.question-wrapper {
		position: relative;
		background: #f5f7fa;
		padding-top: 60px;
	}

	.content-wrapper {
		width: 1257px;
		margin: 0 auto;
		padding: 72px 0 30px;
		display: flex;
		align-items: start;
		.left-content {
			position: fixed;
			top: 144px;
			z-index: 1999;
			display: flex;
			flex-direction: column;
			align-items: center;
			font-size: 12px;
			p {
				width: 42px;
				height: 44px;
				background: #ffffff;
				border-radius: 2px;
				box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
				margin-bottom: 10px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				color: #63656e;
				.icon {
					height: 16px;
					width: 16px;
					display: inline-block;
					position: relative;
					&::before, &::after {
						content: '';
						height: 16px;
						width: 16px;
						position: absolute;
						z-index: 1;
						display: none;
					}
				}
				&.comment-content {
					.icon {
						background: url("../../images/community/comment3.png");
						background-size: 100% 100%;
						&::before {
							background: url('../../images/community/comment4.png');
							background-size: 100% 100%;
						}
					}
				}
				&.follow-content {
					.icon {
						background: url("../../images/community/like3.png");
						background-size: 100% 100%;
						&::before {
							background: url('../../images/community/like4.png');
							background-size: 100% 100%;
						}
						&::after {
							background: url('../../images/community/like5.png');
							background-size: 100% 100%;
						}
					}
				}
				&.great-content {
					.icon {
						background: url("../../images/community/great3.png");
						background-size: 100% 100%;
						&::before {
							background: url('../../images/community/great4.png');
							background-size: 100% 100%;
						}
						&::after {
							background: url('../../images/community/great2.png');
							background-size: 100% 100%;
						}
					}
				}
				&.favorite-content {
					.icon {
						background: url("../../images/community/favorite3.png");
						background-size: 100% 100%;
						&::before {
							background: url('../../images/community/favorite4.png');
							background-size: 100% 100%;
						}
						&::after {
							background: url('../../images/community/favorite2.png');
							background-size: 100% 100%;
						}
					}
					
				}
				&:hover {
					color: #3a84ff;
					.icon::before {
						display: block;
						z-index: 3;
					}
				}
				&.is-follow, &.is-great, &.is-favorite {
					color: #3a84ff;
					.icon {
						background: none;
						&::before {
							display: none !important;
						}
						&::after {
							display: block;
							z-index: 3;
						}
					}
				}
			}
		}
		.center-content {
			width: 830px;
			margin-left: 59px;
			.center-top-content {
				margin-bottom: 10px;
				width: 830px;
				padding-top: 20px;
				background-color: #ffffff;
				box-shadow: 0px 2px 4px 0px rgba(9, 11, 26, 0.1);
				.basic-info {
					padding: 0 20px;
					font-size: 12px;
					.head-title {
						display: flex;
						align-items: center;
						color: #313238;
						.reprint {
            	width: 44px;
            	height: 22px;
            	background: #FFF1DB;
            	color: #FE9C00;
            	border-radius: 2px;
            	font-family: MicrosoftYaHei;
            	font-size: 12px;
            	text-align: center;
            	line-height: 22px;
            	margin-right: 8px;
            }
            .original {
              width: 44px;
              height: 22px;
              background: #E4FAF0;
              border-radius: 2px;
              font-family: MicrosoftYaHei;
              font-size: 12px;
              color: #14A568;
              text-align: center;
              line-height: 22px;
              margin-right: 8px;
            }
						img {
							width: 19px;
							height: 20px;
							margin-right: 8px;
						}
						.solved {
							margin-left: 3px;
							line-height: 16px;
							font-size: 12px;
							border-radius: 2px;
							padding: 3px 7px;
							color: #14a568;
							background: #e4faf0;
							font-weight: normal;
						}
						h1 {
							font-size: 18px;
							font-weight: 700;
							word-break: break-all;
						}
					}
					.tags {
						padding-bottom: 12px;
						border-bottom: 1px solid #f4f4f4;
						display: flex;
						flex-wrap: wrap;
						align-items: center;
						> li {
							flex-shrink: 0;
							padding: 0 12px;
							margin: 0 10px 10px 0;
							line-height: 19px;
							color: #888991;
							background: #fafafc;
							border-radius: 11px;
							border: 1px solid #e3e8f2;
						}
					}
					.questioner-info {
						margin: 10px 0;
						display: flex;
						align-items: center;
						position: relative;
						line-height: 16px;

						span {
							color: #63656e;
							&.user-portrait {
								img {
									cursor: pointer;
									border-radius: 50%;
								}
							}
							&.questioner-name {
								margin: 0 5px 0 7px;
								color: #828282;
							}
						}
						.question-view {
							margin-left: 22px;
							display: flex;
							align-items: center;
							.view-icon {
								height: 16px;
								width: 16px;
								display: inline-block;
								margin-right: 5px;
								background: url('../../images/community/eye-open.png');
                                background-size: 100% 100%;
							}
						}
						.editor-list {
							position: absolute;
							top: 5px;
							right: 0;
							display: flex;
							align-items: center;
							li {
								color: #63656e;
								margin-left: 10px;
								cursor: pointer;
								&:hover {
									color: #3a84ff;
								}
							}
						}
					}
				}
				.question-content {
					padding: 0 20px;
					.question-desc {
						padding: 20px 0;
						font-size: 14px;
						line-height: 24px;
						color: #4f515e;
						border-bottom: none !important;
						p {
							img {
							width: 100%;
							cursor: pointer;
							}
						}
					}
				}
			}
		}
		.right-content {
			margin-left: 12px;
			width: 356px;
			box-shadow: 0px 2px 4px 0px rgba(9, 11, 26, 0.1);
			.similar-answers {
				width: 356px;
				background-color: #ffffff;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// deatils.vue?2a869533